export { default as CmsLeftRightHero } from './CmsLeftRightHero';
